import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=0a39a256"
import script from "./PedidosTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports